<template>
  <div class="page page__list">
    <div class="filter-bar">
      <span>
        {{ activeTab }}
        <i class="caret"></i>
      </span>
      <select class="filter-item__select" v-model="activeTab" @change="select">
        <option :value="item.name" v-for="(item, index) in list" :key="index">
          {{ item.name }}&nbsp;&nbsp;&nbsp;<span v-if="item.num">{{
            item.num
          }}</span>
        </option>
      </select>
    </div>
    <div class="weui-cells" v-if="tableList && tableList.length > 0">
      <router-link
        v-for="(items, index2) in tableList"
        :key="index2"
        :to="{ name: 'OperatingRiskDetail', params: { items, activeTab } }"
      >
        <div v-if="activeTab == '注销备案'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.name }}</p>
            <p class="list-item-muted">
              {{ items.listPage.registrationOrgan }}
            </p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ items.listPage.reason }}</p>
          </div>
        </div>
        <div v-if="activeTab == '简易注销'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.announcementName }}</p>
            <p class="list-item-muted">{{ items.listPage.result }}</p>
            <p class="list-item-muted">
              {{ items.listPage.announcementDate }}
            </p>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
        <div v-if="activeTab == '清算信息'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.dutyer }}</p>
            <p class="list-item-muted">
              {{ items.listPage.member }}
            </p>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
        <div v-if="activeTab == '严重违法'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p class="text-hide">{{ items.listPage.reason }}</p>
            <p class="list-item-muted">
              {{ items.listPage.inclusionDate }}
            </p>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
        <div v-if="activeTab == '环保处罚'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p class="text-hide">{{ items.listPage.penaltyUnit }}</p>
            <p class="list-item-muted">
              {{ items.listPage.decisionNumber }}
            </p>
            <p class="list-item-muted">{{ items.listPage.penaltyDate }}</p>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
        <div v-if="activeTab == '税收违法'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.natureCase }}</p>
            <p class="list-item-muted">
              {{ items.listPage.taxOrgans }}
            </p>
            <p class="list-item-muted">{{ items.listPage.releaseDate }}</p>
          </div>
          <div class="weui-cell__ft">
          </div>
        </div>
        <div v-if="activeTab == '欠税公告'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>
              {{ items.listPage.taxAuthority }}
            </p>
            <p class="list-item-muted">{{ items.listPage.releaseDate }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ items.listPage.newArrearsBalance }}</p>
          </div>
        </div>
        <div v-if="activeTab == '经营异常'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p >{{ items.listPage.decisionOrgans }}</p>
            <p class="list-item-muted">
              {{ items.listPage.inclusionDate }}
            </p>
          </div>
          <div class="weui-cell__ft">
          </div>
        </div>
        <div v-if="activeTab == '政府约谈'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.newsTitle }}</p>
            <p class="list-item-muted">
              {{ items.listPage.interviewsAuthority }}
            </p>
            <p class="list-item-muted">{{ items.listPage.newsDate }}</p>
          </div>
          <div class="weui-cell__ft">
          </div>
        </div>
        <div v-if="activeTab == '产品召回'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.recallProduct }}</p>
            <p class="list-item-muted">
              {{ items.listPage.recallEnterprise }}
            </p>
            <p class="list-item-muted">{{ items.listPage.newsDate }}</p>
          </div>
          <div class="weui-cell__ft">
          </div>
        </div>
        <div v-if="activeTab == '土地抵押'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.location }}</p>
            <p class="list-item-muted">
              {{ items.listPage.landUse }}
            </p>
            <p class="list-item-muted">{{ items.listPage.beginAndEndDate }}</p>
          </div>
          <div class="weui-cell__ft">
          </div>
        </div>
        <div v-if="activeTab == '股权出质'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.registNumber}}</p>
            <p class="list-item-muted">
              {{ items.listPage.pledgedEnterprise }}
            </p>
            <p class="list-item-muted">{{ items.listPage.recordDate }}</p>
          </div>
          <div class="weui-cell__ft">
          </div>
        </div>
        <div v-if="activeTab == '股权质押'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.pledgedSharesNum }}</p>
            <p class="list-item-muted">
              {{ items.listPage.shareholderName }}
            </p>
            <p class="list-item-muted">{{ items.listPage.announcementDate }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ items.listPage.pledgedSharesMarketValue }}</p>
            <p>{{ items.listPage.status }}</p>
          </div>
        </div>
        <div v-if="activeTab == '对外担保'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p class="text-hide">{{ items.listPage.guarantor }}</p>
            <p class="list-item-muted">{{ items.listPage.announcementDate }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ items.listPage.guarantyMoney }}</p>
            <p>{{ items.listPage.guarantyStyle }}</p>
          </div>
        </div>
        <div v-if="activeTab == '动产抵押'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.registNumber }}</p>
            <p class="list-item-muted">
              {{ items.listPage.mortgagee }}
            </p>
            <p class="list-item-muted">{{ items.listPage.debtMaturities }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ items.listPage.byGuaranteedDebtAmount }}</p>
            <p>{{ items.listPage.byGuaranteedDebtType }}</p>
          </div>
        </div>
        <div v-if="activeTab == '劳动仲裁'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.applicant }}</p>
            <p class="list-item-muted">
              {{ items.listPage.caseNumber }}
            </p>
            <p class="list-item-muted">{{ items.listPage.releaseDate }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ items.listPage.defendingApplicant }}</p>
          </div>
        </div>
        <div v-if="activeTab == '开庭公告'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.applicant }}</p>
            <p class="list-item-muted">
              {{ items.listPage.caseNumber }}
            </p>
            <p class="list-item-muted">{{ items.listPage.courtDate }}</p>
          </div>
          <div class="weui-cell__ft">
          </div>
        </div>
        <div v-if="activeTab == '公示催告'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.applicant }}</p>
            <p class="list-item-muted">
              {{ items.listPage.billNumber }}
            </p>
            <p class="list-item-muted">{{ items.listPage.announcementDate }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ items.listPage.billAmount }}</p>
          </div>
        </div>
        <div v-if="activeTab == '违规处理'" class="weui-cell weui-cell_access">
          <div class="weui-cell__bd">
            <p>{{ items.listPage.punishPerson }}</p>
            <p class="list-item-muted">
              {{ items.listPage.handler }}
            </p>
            <p class="list-item-muted">{{ items.listPage.announcementDate }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ items.listPage.punishType }}</p>
          </div>
        </div>
      </router-link>
    </div>
    <div class="empty" v-else>
      暂无数据
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: "注销备案",
      list: [
        {
          name: "注销备案",
          num: 0,
        },
        {
          name: "简易注销",
          num: 0,
        },
        {
          name: "清算信息",
          num: 0,
        },
        {
          name: "严重违法",
          num: 0,
        },
        {
          name: "环保处罚",
          num: 0,
        },
        {
          name: "税收违法",
          num: 0,
        },
        {
          name: "欠税公告",
          num: 0,
        },
        {
          name: "经营异常",
          num: 0,
        },
        {
          name: "政府约谈",
          num: 0,
        },
        {
          name: "产品召回",
          num: 0,
        },
        {
          name: "土地抵押",
          num: 0,
        },
        {
          name: "股权出质",
          num: 0,
        },
        {
          name: "股权质押",
          num: 0,
        },
        {
          name: "对外担保",
          num: 0,
        },
        {
          name: "动产抵押",
          num: 0,
        },
        {
          name: "劳动仲裁",
          num: 0,
        },
        {
          name: "开庭公告",
          num: 0,
        },
        {
          name: "公示催告",
          num: 0,
        },
        {
          name: "违规处理",
          num: 0,
        }
      ],
      tableList: [],
    };
  },
  created() {
    this.loadData();
    this.select();
  },
  methods: {
    select() {
      let me = this,
        name = me.$route.query.name;
      if (!name || name == "") {
        return;
      }

      me.$loading({
        url:
          "/api/document/eOperatingRisk/getRiskInfo?name=" +
          name +
          "&riskName=" +
          me.activeTab,
      }).then(function (res) {
        if (res.data) {
          me.tableList = res.data;
        }
      });
     
    },
    loadData() {
      let me = this,
        name = me.$route.query.name;
      if (!name || name == "") {
        return;
      }

      me.$loading({
        url: "/api/document/eOperatingRisk/count?name=" + name,
      }).then(function (res) {
        if (res.data) {
          me.list.forEach((item) => {
            for (const key in res.data) {
              if (key == item.name) {
                item.num = res.data[key];
              }
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.page{
  margin-top: 50px;
}
.empty {
  width: 100%;
  height: 300px;
  line-height: 300px;
  text-align: center;
  color: #727272;
  font-weight: bold;
  
}
.filter-bar {
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  position: relative;
}
.filter-bar span {
  margin: 0 auto;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}
.text-hide {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
.weui-cell {
  border-top: 1px solid #eee;
}
.weui-cells > a:first-child > .weui-cell {
  border-top: 0;
}
.weui-cells {
  overflow-y: scroll;
}
</style>